import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "UpdatePaymentInfo",
    component: () =>
        __SERVER__ ? require("./update-payment-info-view") : import("./update-payment-info-view")
});

export default definition;
